import type * as zod from 'zod';

import { CustomGripperConfiguration } from './CustomGripperConfiguration';

export const CustomGripperState = CustomGripperConfiguration;

export type CustomGripperState = zod.infer<typeof CustomGripperState>;
